<template>
  <div id="app" style="display: inline-block">
    <el-button size="small" @click="schoolAdd" type="primary"
      >选择学校</el-button
    >
    <el-dialog
      title="学校列表"
      :before-close="handleClose"
      :visible.sync="schoolDialog"
    >
      <el-form :inline="true" align="left" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="schoolSearch"
            size="small"
            placeholder="请输入学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click.native="searchSchool"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click.native="closeSchoolDialog"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="schoolState"
        :data="schoolList"
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        border
        stripe
        class="school-main"
        ref="schoolTable"
      >
        <el-table-column prop="" label="" align="center" width="60">
          <template slot-scope="scope">
            <el-radio
              v-model="schoolId"
              :label="scope.row.id"
              @change="xuanze(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          label="学校识别码"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="学校名称"
          min-width="250"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          :hide-on-single-page="true"
          :current-page.sync="schoolPage"
          @size-change="schoolSizeChange"
          @current-change="schoolCurrentChange"
          :page-size="schoolPagesize"
          layout="total, prev, pager, next,jumper"
          :total="schoolTotalcount"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK, BASE_URLLIST } from "@/api/index";
export default {
  data() {
    return {
      schoolList: [], //直播学校列表
      school: {}, //已选择学校
      schoolDialog: false, //学校列表弹窗
      schoolSearch: "", //搜索学校关键字
      schoolPage: 1, //当前页
      schoolPagesize: 10, //每页显示数量
      schoolTotalcount: 0, //列表总数
      schoolState: false, //加载状态
      schoolId: -1, //学校ID
      groupId: localStorage.getItem("groupId"),
    };
  },
  props: {
    schoolIds: {
      type: Number,
      required: false,
    },
  },
  created() {
    
  },
  methods: {
    schoolAdd() {
      this.getSchoolList();
      this.schoolDialog = true;
    },
    //获取学校列表
    getSchoolList() {
      //参数
      let params = {
        curPage: this.schoolPage,
        pageSize: this.schoolPagesize,
        name: this.schoolSearch,
        groupId: this.groupId,
      };
      this.schoolState = true;
      let _this = this;
      //接口
      homeApi
        .getSchoolList(params)
        .then((res) => {
          //关闭加载
          this.schoolState = false;
          let { data } = res;
          if (data.code === ERR_OK) {
            //学校列表
            let list = data.data.dataList;
            _this.schoolList = [];
            if (list.length > 0) {
              _this.schoolTotalcount = data.data.totalCount;
              _this.schoolList = list;
            } else {
              _this.schoolPagelast = true;
            }
          } else {
            _this.$toast.center(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //选择学校
    xuanze(row) {
      this.school = row;
    },
    // diog关闭
    handleClose() {
      this.schoolId = "";
      this.schoolDialog = false;
    },
    //搜索学校
    searchSchool() {
      this.schoolPage = 1;
      this.schoolList = [];
      this.schoolTotalcount = 0;
      this.getSchoolList();
    },
    //跳转到第几页
    schoolCurrentChange(val) {
      this.schoolPage = val;
      this.getSchoolList();
    },
    //改变每页显示数量
    schoolSizeChange(val) {
      this.schoolPagesize = val;
      this.getSchoolList();
    },
    //隐藏学校列表弹窗
    closeSchoolDialog() {
      this.$emit("schoolData", this.school);
      this.schoolDialog = false;
    },
  },
  mounted() {
    setTimeout(() => {
      this.schoolId = this.schoolIds;
    },1000);
  },
};
</script>
<style scoped>
.page {
  margin-top: 10px;
}
.demo-form-inline {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/public/schoolDlog.vue